import { render } from "./FinancesHeaderSection.vue?vue&type=template&id=4320aaf5"
import script from "./FinancesHeaderSection.vue?vue&type=script&lang=js"
export * from "./FinancesHeaderSection.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__